/* src/app/upload-file/upload-file.component.css */
/*# sourceMappingURL=upload-file.component.css.map */
